export default __webpack_public_path__ + "static/logo_white-13deb12cb64fdc85246ddcae6005ed10.png";